// Command palette (Cmd+K) state. Hotkey wire-up — в hooks/use-cmd-k.ts.
import { create } from "zustand";

interface CommandPaletteState {
	isOpen: boolean;
	query: string;
	open: () => void;
	close: () => void;
	toggle: () => void;
	setQuery: (query: string) => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set, get) => ({
	isOpen: false,
	query: "",
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false, query: "" }),
	toggle: () => set({ isOpen: !get().isOpen }),
	setQuery: (query) => set({ query }),
}));
